import React, { useEffect, useState } from 'react';
import { CircularProgress, Stack } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import ProductForm from '../components/ProductForm';
import { useGetProductHandler } from '../dataHandlers/getProductHandler';
import { useMutateProductHandler } from '../dataHandlers/mutateProductHandler';

export default function ProductEditPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { product, isLoading: isLoadingData } = useGetProductHandler(id);
  const { onSubmit, error, isPending } = useMutateProductHandler({
    onSuccess: () => navigate('/products'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  if (isLoadingData || !product) return <CircularProgress />;

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <ProductForm
        onSubmit={(payload) => onSubmit({ ...payload, stripe_product_id: product.stripe_product_id }, true)}
        onCancel={() => navigate('/products')}
        initialData={product}
        apiErrors={error}
        isLoading={isPending || isLoadingData || isSubmitting}
        isEdit={true}
      />
    </Stack>
  );
}
